import React from 'react';
import { Check, Clock, CreditCard, ShieldCheck, Zap } from 'lucide-react';
import { CheckoutButton } from './CtaButton';
interface PriceCardProps {
  ctaLabel: string;
  theme?: 'light' | 'dark';
  footnote?: string;
}
const indicadores = [{
  icon: ShieldCheck,
  label: 'Pago seguro'
}, {
  icon: Zap,
  label: 'Acceso inmediato'
}, {
  icon: Clock,
  label: 'Garantía 7 días'
}, {
  icon: CreditCard,
  label: 'Mercado Pago'
}];
export function PriceCard({
  ctaLabel,
  theme = 'light',
  footnote
}: PriceCardProps) {
  const isDark = theme === 'dark';
  return <div className={`mx-auto w-full max-w-xl overflow-hidden rounded-2xl border-2 border-verde shadow-card ${isDark ? 'bg-bordo text-white' : 'bg-white text-tinta'}`} data-id="element-40" data-mp="31dsjk7dde2ne">
      <div className="h-1.5 w-full bg-gradient-to-r from-bordo via-dorado to-verde" aria-hidden="true" data-id="element-41" data-mp="2rk1twz5ibm64" />
      <div className="px-6 py-8 text-center sm:px-10 sm:py-10" data-id="element-42" data-mp="1b61ya0dp2ioo">
        <h3 className={`font-display text-2xl font-bold sm:text-3xl ${isDark ? 'text-white' : 'text-bordo'}`} data-id="element-43" data-mp="1g4d9ofjn1190">
          PROFES DE TELAS RESUELTO™
        </h3>
        <p className={`mt-3 text-sm font-medium sm:text-base ${isDark ? 'text-white/80' : 'text-tintasuave'}`} data-id="element-44" data-mp="3fnj8tkva0qu4">
          7 Tomos + 5 Bonos + Programa Anual de 12 Meses
        </p>

        <div className="mt-7 flex flex-col items-center" data-id="element-45" data-mp="3ono795ihsew5">
          <span className={`text-lg font-medium line-through sm:text-xl ${isDark ? 'text-white/50' : 'text-tintasuave'}`} data-id="element-46" data-mp="3om4q7cp0hztb">
            $49.900
          </span>
          <span className="mt-1 font-display text-[2.75rem] font-bold leading-none text-verde sm:text-6xl" data-id="element-47" data-mp="2g7tanihfouq">
            $19.900 <span className="text-2xl sm:text-3xl" data-id="element-48" data-mp="g9p9pzfvglgj">ARS</span>
          </span>
          <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-dorado/20 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-dorado ring-1 ring-dorado/50 sm:text-sm" data-id="element-49" data-mp="c72pokpg04tw">
            <Check className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="l8iqq1udaulg" /> Ahorrás $30.000
          </span>
        </div>

        <div className="mt-8" data-id="element-51" data-mp="3f0s6a7pbzi8q">
          <CheckoutButton data-id="element-52" data-mp="3j0ity2jk9i91">{ctaLabel}</CheckoutButton>
        </div>

        {footnote && <p className={`mt-5 text-sm leading-relaxed ${isDark ? 'text-white/75' : 'text-tintasuave'}`} style={{
        fontSize: "13px"
      }} data-id="element-53" data-mp="3iy6fw0gxbs19">
            {footnote}
          </p>}

        <ul className="mt-7 grid grid-cols-2 gap-3 text-left sm:grid-cols-4 sm:text-center" data-id="element-54" data-mp="3ssf2k7j9wqri">
          {indicadores.map(({
          icon: Icon,
          label
        }) => <li key={label} className={`flex items-center gap-2 text-xs font-semibold sm:flex-col sm:gap-1.5 ${isDark ? 'text-white/80' : 'text-tintasuave'}`} data-id="element-55" data-mp="6icgnosgnj7c">
              <Icon className="h-4 w-4 shrink-0 text-verde" aria-hidden="true" data-id="element-56" data-mp="fjaetqg7wwi0" />
              <span data-id="element-57" data-mp="2cddtixmz2op6">{label}</span>
            </li>)}
        </ul>
      </div>
    </div>;
}